import { EMAILS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import { serviceRoles } from "config/access";
import EmailsPage from "./container/EmailsPage";

export default function getRoute(userAuth) {
  const { account, postal } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [postal.name]: [postal.roles.user],
  };
  return {
    path: EMAILS,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withSidebar: true,
    withAppBar: true,
    component: EmailsPage,
  };
}
